import { CiMobile1 } from "react-icons/ci";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import ManageAccountTabs from "./Tabs";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import LinkIcon from "../../assets/images/icons/icon_link.svg";
import SendIcon from "../../assets/images/icons/icon-email.svg";
import GoogleIcon from "../../assets/images/icons/icon-google.svg";
import OutlookIcon from "../../assets/images/icons/icon-outlook.svg";
import Myaccount from "../../assets/images/icons/icon_myaccount_header.svg";
import { getCalendarAuthUrl, getNotificationSettingsUser, updateNotificationsSettings } from "../../store/middleware";

import { NotificationAccountStyles } from "./Styles";

function NotificationAccount() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [id, setId] = useState(1);
  const [app, setApp] = useState(false);
  const [userId, setUserId] = useState(0);
  const [email, setEmail] = useState(false);
  const [website, setWebSite] = useState(false);
  const [googleAgenda, setGoogleAgenda] = useState(false);
  const [connectingGoogle, setConnectingGoogle] = useState(false);
  const [microsoftOutlook, setMicrosoftOutlook] = useState(false);
  const [connectingOutlook, setConnectingOutlook] = useState(false);

  const loadInfos = async () => {
    const response = await dispatch(getNotificationSettingsUser(user.id));
    if (!response) return;

    setId(response.id);
    setApp(response.app);
    setEmail(response.email);
    setUserId(response.userId);
    setWebSite(response.website);
    setGoogleAgenda(response.google);
    setMicrosoftOutlook(response.microsoft);
  };

  const handleInputChange = (e) => {
    const { name, checked } = e.target;

    if (name === "website") setWebSite(checked);
    if (name === "email") setEmail(checked);
    if (name === "app") setApp(checked);

    const body = {
      id,
      userId,
      app: name === "app" ? checked : app,
      email: name === "email" ? checked : email,
      website: name === "website" ? checked : website,
    };

    dispatch(updateNotificationsSettings(body));
  };

  const handleConnectGoogleCalendar = async () => {
    try {
      setConnectingGoogle(true);
      const responseURL = await dispatch(getCalendarAuthUrl("google", user.id));
      if (!responseURL) return;

      window.location.href = responseURL;
    } catch (e) {
      console.log("handleConnectGoogleCalendar", e);
    } finally {
      setConnectingGoogle(false);
    }
  };

  const handleConnectOutlookCalendar = async () => {
    try {
      setConnectingOutlook(true);
      const responseURL = await dispatch(getCalendarAuthUrl("microsoft", user.id));
      if (!responseURL) return;

      window.location.href = responseURL;
    } catch (e) {
      console.log("handleConnectOutlookCalendar", e);
    } finally {
      setConnectingOutlook(false);
    }
  };

  useEffect(() => {
    loadInfos();
    setGoogleAgenda(sessionStorage.getItem("@googleCalendarConnected") === "true");
    setMicrosoftOutlook(sessionStorage.getItem("@microsoftCalendarConnected") === "true");
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          typeIcon="custom"
          title={t("MANAGE_ACCOUNT_TITLE")}
          icon={<img src={Myaccount} alt={t("MANAGE_ACCOUNT_TITLE")} />}
        />

        <NotificationAccountStyles>
          <div className="tabs">
            <ManageAccountTabs />

            <div className="tab-content">
              <div className="box">
                <div className="infoNotification">
                  <h2>{t("NOTIFICATION_TITLE")}</h2>

                  <ul>
                    <li>
                      <div className="notificationLeft">
                        <div className="notificationIcon">
                          <img src={LinkIcon} alt={t("WEBSITE")} />
                        </div>
                        <p>{t("WEBSITE")}</p>
                      </div>
                      <div className="switch__container">
                        <input
                          name="website"
                          type="checkbox"
                          checked={website}
                          id="switch-shadow"
                          onChange={handleInputChange}
                          className="switch switch--shadow"
                        />
                        <label htmlFor="switch-shadow">
                          <span>{website ? t("BTN_YES") : t("BTN_NO")}</span>
                        </label>
                      </div>
                    </li>

                    <li>
                      <div className="notificationLeft">
                        <div className="notificationIcon">
                          <img src={SendIcon} alt={t("EMAIL")} />
                        </div>
                        <p>{t("EMAIL")}</p>
                      </div>
                      <div className="switch__container">
                        <input
                          name="email"
                          type="checkbox"
                          checked={email}
                          id="switch-shadow2"
                          onChange={handleInputChange}
                          className="switch switch--shadow2"
                        />
                        <label htmlFor="switch-shadow2">
                          <span>{email ? t("BTN_YES") : t("BTN_NO")}</span>
                        </label>
                      </div>
                    </li>

                    <li>
                      <div className="notificationLeft">
                        <div className="notificationIcon">
                          <CiMobile1 />
                        </div>
                        <p>{t("APP")}</p>
                      </div>
                      <div className="switch__container">
                        <input
                          name="app"
                          checked={app}
                          type="checkbox"
                          id="switch-shadow3"
                          onChange={handleInputChange}
                          className="switch switch--shadow2"
                        />
                        <label htmlFor="switch-shadow3">
                          <span>{app ? t("BTN_YES") : t("BTN_NO")}</span>
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="box boxCalendarLink">
                <div className="calendarLink">
                  <div className="calendarLinkHeader">
                    <h2>{t("CONNECT_YOUR_GOOGLE_ACCOUNT")}</h2>
                  </div>

                  <ul className="calendarLinkList">
                    <li className="calendarLinkItem">
                      <div className="calendarLinkLeft">
                        <div className="calendarLinkIcon">
                          <img src={GoogleIcon} alt="Google" />
                        </div>
                        <div className="calendarLinkText">
                          <h3>{t("GOOGLE_CALENDAR")}</h3>
                          <span>{t("SYNC_YOUR_GMAIL_ACCOUNT")}</span>
                        </div>
                      </div>

                      <div className="calendarLinkRight">
                        {googleAgenda ? (
                          <span className="calendarConnected">{t("CONNECTED")}</span>
                        ) : (
                          <button
                            type="button"
                            disabled={connectingGoogle}
                            className="calendarConnectBtn"
                            onClick={handleConnectGoogleCalendar}
                          >
                            {connectingGoogle ? t("CONNECTING") : t("CONNECT")}
                          </button>
                        )}
                      </div>
                    </li>

                    <li className="calendarLinkItem" style={{ display: "none" }}>
                      <div className="calendarLinkLeft">
                        <div className="calendarLinkIcon calendarLinkIconOutlook">
                          <img src={OutlookIcon} alt="Google" />
                        </div>
                        <div className="calendarLinkText">
                          <h3>{t("MICROSOFT_OUTLOOK")}</h3>
                          <span>{t("SYNC_WITH_YOUR_OUTLOOK_ACCOUNT")}</span>
                        </div>
                      </div>

                      <div className="calendarLinkRight">
                        {microsoftOutlook ? (
                          <span>{t("BTN_YES")}</span>
                        ) : (
                          <button
                            type="button"
                            disabled={connectingOutlook}
                            className="calendarConnectBtn"
                            onClick={handleConnectOutlookCalendar}
                          >
                            {connectingOutlook ? t("CONNECTING") : t("CONNECT")}
                          </button>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </NotificationAccountStyles>
      </section>
    </div>
  );
}

export default NotificationAccount;
